import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'formik';

// This can be used to override error message to be empty
// Commonly used with Yup validationSchemas to ignore certain
// default validation error messages.
export const NO_ERROR_MESSAGE = ' ';

const BareComponent = ({ field, formik }) => {
  // Searching status, then errors based on Formik author's recommendation: https://stackoverflow.com/a/54328567/3897591
  const message =
    get(formik.touched, field) && (get(formik.status, field) || get(formik.errors, field));
  if (!message || message === NO_ERROR_MESSAGE) {
    return null;
  }

  return (
    <div className="has-error">
      <span className="help-block error-msg">{message}</span>
    </div>
  );
};

BareComponent.propTypes = {
  formik: PropTypes.shape({
    errors: PropTypes.object,
    status: PropTypes.object,
    touched: PropTypes.object,
  }),
  field: PropTypes.string.isRequired,
};

BareComponent.defaultProps = {
  formik: {
    errors: {},
    status: {},
    touched: {},
  },
};

export default connect(BareComponent);
